import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomMaskedInput, CustomMaskedInputProps } from '../../../custom_shared/components';
import { WithInput } from '../../types';
import { useInputHighlighting, useGlobalInputState } from '../../hooks';

export type CustomMaskedInputWrapperProps = WithInput<CustomMaskedInputProps>;

const CustomMaskedInputWrapper: React.FC<CustomMaskedInputWrapperProps> = (props: CustomMaskedInputWrapperProps) => {
    const { input, ...rest } = props;

    const [containerRef, setContainerRef] = React.useState<React.RefObject<HTMLDivElement> | null>(null);

    const { containerStyle } = useInputHighlighting(input, containerRef);

    const globalInputState = useGlobalInputState(input, props);

    return (
        <CustomMaskedInput
            containerStyle={containerStyle}
            getContainerRef={setContainerRef}
            {...rest}
            {...globalInputState}
        />
    );
};

export default observer(CustomMaskedInputWrapper);
